import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import DateRangePickerWrapper from "./DateRangePickerWrapper";
import Uri from "jsuri";

import calendarIcon from "./../../i/icons/calendar.svg";

const DatePicker = (props) => {
  const containerRef = useRef(null);

  const [open, setOpen] = useState(false);

  const handleToggleDropdown = () => {
    setOpen(!open);
  };

  const handleGlobalDateChangeDatepicker = (start, end) => {
    props.widgetHeaderGlobalDateChange(start, end);
  };

  const getSelectedDateName = () => {
    let current_date = "";

    const uri = new Uri(props.url);

    if (uri.hasQueryParam("t")) {
      const date_range_name = props.dateRanges
        ? props.dateRanges.find((o) => o.slug === uri.getQueryParamValue("t"))
        : {};
      current_date = date_range_name.name;
    } else {
      (props.dateRanges || []).map((range) => {
        if (
          moment(new Date(range.from)).utc().format("YYYY-MM-DD") ===
            moment(new Date(props.startDate)).utc().format("YYYY-MM-DD") &&
          moment(new Date(range.to)).utc().format("YYYY-MM-DD") ===
            moment(new Date(props.endDate)).utc().format("YYYY-MM-DD")
        ) {
          current_date = range.name;
        }
        return current_date;
      });

      current_date = current_date
        ? current_date
        : props.startDate + "/" + props.endDate;
    }

    return current_date;
  };

  const handleClickOutside = (e) => {
    if (e.target.classList.contains("datepicker-close-button")) {
      setOpen(false);
    } else if (containerRef.current.contains(e.target)) {
      return;
    } else {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={containerRef} className="datepicker-container">
      <button
        className="datepicker-open-button"
        onClick={() => handleToggleDropdown()}
      >
        <span>{getSelectedDateName()}</span>
        <img src={calendarIcon} alt="Calendar" className="datepicker-icon" />
      </button>
      {open && (
        <div className="datepicker-dropdown">
          <DateRangePickerWrapper
            {...props}
            selectedDate={getSelectedDateName()}
            handleGlobalDateChangeDatepicker={handleGlobalDateChangeDatepicker}
          />
        </div>
      )}
    </div>
  );
};

export default DatePicker;
